import clsx from 'clsx';
import React from 'react';

import useServerSideRendering from '@hooks/useServerSideRendering';
import { Comment, CommentableType } from '@utils/backend-api/comments';

import CommentFormContent from './Content';
import CommentFormHeader from './Header';

export default function CommentForm({
  comment,
  commentableId,
  commentableType,
  replyingTo,
  hideReplyForm,
  hideEditForm,
}: {
  comment?: Comment;
  commentableId: number;
  commentableType: CommentableType;
  replyingTo?: string;
  hideReplyForm?: () => void;
  hideEditForm?: () => void;
}) {
  const isEditing = !!comment;
  const hydrated = useServerSideRendering();
  return (
    <div
      className={clsx('comment-form', {
        'ml-64': !!replyingTo,
      })}
      style={{
        display: 'block', // Overriding hidden style used in Rails erb comments
      }}
    >
      <CommentFormHeader
        isEditing={isEditing}
        isReplyForm={!!replyingTo}
        hideReplyForm={hideReplyForm}
        hideEditForm={hideEditForm}
      />
      <div>
        {hydrated && (
          <CommentFormContent
            comment={comment}
            commentableId={commentableId}
            commentableType={commentableType}
            replyingTo={replyingTo}
            hideReplyForm={hideReplyForm}
            hideEditForm={hideEditForm}
          />
        )}
      </div>
    </div>
  );
}
